<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12 pageheader">
      <div class="fl-right">
        <button
          type="button"
          pButton
          (click)="export()"
          class="ui-button-success csv-export">
          <i class="mdl2-excel"></i> Export All Events
        </button>
      </div>
    </div>
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="scrollableCols"
          [value]="eventsDisplayed"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="550px"
          dataKey="m365eventId"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          [totalRecords]="totalRecords"
          [lazy]="true"
          (onLazyLoad)="this.loadEvents($any($event))"
          (onFilter)="applyFilter($event)"
          exportFilename="M365EventRecords">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <input
                type="text"
                pInputText
                size="30"
                placeholder="Search"
                (keyup)="
                  eventSearchFilterRequest.searchString = $any(
                    $event.target
                  ).value
                "
                [(ngModel)]="eventSearchFilterRequest.searchString"
                (input)="onSearchInput($event, dt)"
                style="width: auto"
                [value]="
                  dt.filters['global'] ? $any(dt.filters['global']).value : ''
                " />
              <i class="fa fa-search ml-2"></i>
              <span class="pageInfo visiblelg resettble">{{
                currentPageInfo
              }}</span>
              <span style="float: right; position: relative; top: 12px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header>
            <tr class="row">
              <th
                [pSortableColumn]="'eventKey'"
                (click)="sort('eventKey')"
                class="colsmall">
                Event Key<p-sortIcon [field]="'eventKey'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'requestDate'"
                (click)="sort('requestDate')"
                class="colsmall">
                Request Date<p-sortIcon [field]="'requestDate'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'eventStatusName'"
                (click)="sort('eventStatusName')"
                class="colsmall">
                Event Status<p-sortIcon
                  [field]="'eventStatusName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'l1InternalStatus'"
                (click)="sort('l1InternalStatus')"
                class="colsmall">
                L1 Internal Status<p-sortIcon
                  [field]="'l1InternalStatus'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'eventType'"
                (click)="sort('eventType')"
                class="colsmall">
                Event Sub Type<p-sortIcon [field]="'eventType'"></p-sortIcon>
              </th>
              @if (showTargetProduct) {
                <th
                  [pSortableColumn]="'eventTargetProductName'"
                  (click)="sort('eventTargetProductName')"
                  class="colsmall">
                  Target Product<p-sortIcon
                    [field]="'eventTargetProductName'"></p-sortIcon>
                </th>
              }
              <th
                [pSortableColumn]="'partnerOrgName'"
                (click)="sort('partnerOrgName')"
                class="colsmall">
                Partner Name<p-sortIcon [field]="'partnerOrgName'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'partnerMpnid'"
                (click)="sort('partnerMpnid')"
                class="colsmall">
                Partner ID
                <p-sortIcon [field]="'partnerMpnid'"></p-sortIcon>
              </th>
            </tr>
            <tr class="row">
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="eventSearchFilterRequest.eventKey" />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="eventSearchFilterRequest.requestDate" />
              </th>
              <th class="dashtable colsmall">
                <p-multiSelect
                  [options]="eventStatusDropdownItems"
                  appendTo="body"
                  placeholder="Event Status"
                  [(ngModel)]="eventSearchFilterRequest.eventStatus"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
              <th class="dashtable colsmall">
                <p-multiSelect
                  [options]="l1InternalStatusDropdownItems"
                  appendTo="body"
                  placeholder="L1 Internal Status"
                  [(ngModel)]="eventSearchFilterRequest.l1InternalStatus"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
              <th class="dashtable colsmall">
                <p-multiSelect
                  [options]="eventTypeDropdownItems"
                  appendTo="body"
                  placeholder="Event Sub Type"
                  [(ngModel)]="eventSearchFilterRequest.eventType"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
              @if (showTargetProduct) {
                <th class="dashtable colsmall">
                  <p-multiSelect
                    [options]="targetProductDropdownItems"
                    appendTo="body"
                    placeholder="Target Product"
                    [(ngModel)]="
                      eventSearchFilterRequest.eventTargetProductName
                    "
                    (onChange)="searchOrFilterEngagements()"></p-multiSelect>
                </th>
              }
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="eventSearchFilterRequest.partnerOrgName" />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="eventSearchFilterRequest.partnerMpnid" />
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr
              (dblclick)="editRequestDetails(rowData.eventRegistrationId)"
              class="row">
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }}"
                  ><a
                    (click)="editRequestDetails(rowData.eventRegistrationId)"
                    (keydown.enter)="
                      editRequestDetails(rowData.eventRegistrationId)
                    "
                    tabindex="0"
                    class="editlink"
                    >{{ rowData.eventRegistrationId }}</a
                  ></span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.requestDate | date: 'yyyy-MM-dd'
                  }}"
                  >{{ rowData.requestDate | date: 'yyyy-MM-dd' }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.eventStatusName
                  }}"
                  >{{ rowData.eventStatusName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.l1InternalStatusName
                  }}"
                  >{{ rowData.l1InternalStatusName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.eventName
                  }}"
                  >{{ rowData.eventName }}</span
                >
              </td>
              @if (showTargetProduct) {
                <td class="colsmall">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.eventTargetProductId }} : {{
                      rowData.eventTargetProductName
                    }}"
                    >{{ rowData.eventTargetProductName }}</span
                  >
                </td>
              }
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.partnerOrgName
                  }}"
                  >{{ rowData.partnerOrgName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.eventRegistrationId }} : {{
                    rowData.partnerMpnid
                  }}"
                  >{{ rowData.partnerMpnid }}</span
                >
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

@if (loadEditComponent) {
  <p-dialog
    id="engagementEdit"
    [transitionOptions]="'10ms'"
    [(visible)]="editNav"
    modal="true"
    [maximizable]="true"
    showEffect="fade"
    [style]="{ width: '90vw' }"
    (onHide)="onCloseEditModal()"
    [draggable]="false"
    [resizable]="false">
    <app-edit-event
      [eventRegistrationId]="eventEditInput.eventRegistrationId"
      [programTypeGUID]="eventsProgram"
      #editNavChild
      (showFullscreen)="onShowFullScreenChanged($event)"
      (closeEditSidebar)="onCloseEditModal()"></app-edit-event>
  </p-dialog>
}

@if (canShowEventPreviewModel) {
  <app-event-preview
    [eventPreviewInput]="eventPreviewInput"
    (closePreviewModal)="closePreview()"></app-event-preview>
}

@if (canShowCustomerPreviewModel) {
  <app-customer-validation-preview
    [customerValidationPreviewInput]="customerValidationPreviewInput"
    (closePreviewModal)="
      closeCustomerPreview()
    "></app-customer-validation-preview>
}
